// This is the anchor link for context option
import { useMemo } from "react";
import { useActiveAnchor } from "../../../context/active-anchor-context/ActiveAnchorContext";

export default function AnchorLink2({ href, onClick, className, ...rest }) {
  const id = useMemo(() => (href || "").replace(/^#/, ""), [href]);
  const ctx = useActiveAnchor(); // { activeId, setActiveId, getOffset }
  const active = ctx?.activeId === id;

  const handleClick = (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (!el || !ctx) return;

    ctx.setActiveId(id); // clear others immediately
    window.history.pushState({}, "", href);
    const top = el.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: top - ctx.getOffset() + 1, behavior: "smooth" });
    onClick?.(e);
  };

  return (
    <a
      {...rest}
      href={href}
      onClick={handleClick}
      className={`${className ?? ""} ${active ? "active" : ""}`.trim()}
    />
  );
}
